import { IconWorkHome, IconMarkAsUnread, IconConstruction, IconNotifications, IconFilledDatabase, IconChat } from "@/assets/icons";
import { AppRoutes, ContactRoutes, MatchRoutes, SystemSettingRoutes, MasterDataRoutes, InformationRoutes, ChatRoutes } from "@/routes/config";
import { TMenu } from "@/types/menu";

export const menus: TMenu[] = [
  {
    text: "求人紹介向け",
    children: [
      {
        text: "紹介会社管理",
        icon: IconWorkHome,
        path: AppRoutes.duringContractList,
        relatedRoutes: MatchRoutes,
      },
    ],
  },
  {
    text: "システム管理",
    children: [
      { text: "お知らせ配信", icon: IconNotifications, path: AppRoutes.information, relatedRoutes: InformationRoutes },
      { text: "お問い合わせ管理", icon: IconMarkAsUnread, path: AppRoutes.unresolvedContact, relatedRoutes: ContactRoutes },
      { text: "チャット管理", icon: IconChat, path: AppRoutes.chat, relatedRoutes: ChatRoutes },
      { text: "マスターデータ管理", icon: IconFilledDatabase, path: AppRoutes.masterData, relatedRoutes: MasterDataRoutes },
      { text: "システム設定", icon: IconConstruction, path: AppRoutes.emailSetting, relatedRoutes: SystemSettingRoutes },
    ],
  },
] as const;
